import { Empty as AntdEmpty } from 'antd'

import NoResultsEmptyImage from './NoResultsEmptyImage'

export const Empty = Object.assign(AntdEmpty, {
  PRESENTED_IMAGE_NO_RESULTS: <NoResultsEmptyImage />
})
